import api, { refreshSession } from './api'

export const authService = {
  async login({ email, password }) {
    const loginValue = (email || '').trim()
    const { data } = await api.post('/auth/login', { login: loginValue, password })
    return data.data // { tokens: {...}, user: {...} }
  },

  /** Public self-signup (customer role). Returns the same shape as login. */
  async register({ name, email, password }) {
    const { data } = await api.post('/auth/register', { name, email, password })
    return data.data
  },

  async forgotPassword(email) {
    await api.post('/auth/forgot-password', { email })
  },

  async resetPassword({ token, newPassword }) {
    const { data } = await api.post('/auth/reset-password', { token, new_password: newPassword })
    return data.data
  },

  /** Refresh the stored session (single-flight, cross-tab safe). Resolves 'ok' | 'invalid' | 'transient' | 'skip'. */
  async refresh() {
    return refreshSession()
  }
}
